import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  Typography,
  Avatar,
  Box,
  Divider,
  Link as MuiLink
} from '@mui/material';
import DefaultProfile from "../images/avatar.png";

class ProfileTabs extends Component {
    render() {
        const { following, followers, posts } = this.props;
        return (
            <Box>
                <Grid container spacing={3}>
                    {/* Followers Section */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h5" color="primary" gutterBottom>
                            {followers.length} Followers
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        {followers.map((person, i) => (
                            <Box
                                key={i}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 2
                                }}
                            >
                                <MuiLink
                                    component={Link}
                                    to={`/user/${person._id}`}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        '&:hover': {
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    <Avatar
                                        src={`${process.env.REACT_APP_API_URL}/user/photo/${person._id}`}
                                        alt={person.name}
                                        sx={{ width: 30, height: 30, mr: 2 }}
                                        imgProps={{
                                            onError: (e) => { e.target.src = DefaultProfile; }
                                        }}
                                    />
                                    <Typography variant="h6">
                                        {person.name}
                                    </Typography>
                                </MuiLink>
                            </Box>
                        ))}
                    </Grid>

                    {/* Following Section */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h5" color="primary" gutterBottom>
                            {following.length} Following
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        {following.map((person, i) => (
                            <Box
                                key={i}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 2
                                }}
                            >
                                <MuiLink
                                    component={Link}
                                    to={`/user/${person._id}`}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        '&:hover': {
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    <Avatar
                                        src={`${process.env.REACT_APP_API_URL}/user/photo/${person._id}`}
                                        alt={person.name}
                                        sx={{ width: 30, height: 30, mr: 2 }}
                                        imgProps={{
                                            onError: (e) => { e.target.src = DefaultProfile; }
                                        }}
                                    />
                                    <Typography variant="h6">
                                        {person.name}
                                    </Typography>
                                </MuiLink>
                            </Box>
                        ))}
                    </Grid>

                    {/* Posts Section */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h5" color="primary" gutterBottom>
                            {posts.length} Posts
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        {posts.map((post, i) => (
                            <Box key={i} sx={{ mb: 2 }}>
                                <MuiLink
                                    component={Link}
                                    to={`/post/${post._id}`}
                                    sx={{
                                        textDecoration: 'none',
                                        '&:hover': {
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    <Typography variant="h6">
                                        {post.title}
                                    </Typography>
                                </MuiLink>
                            </Box>
                        ))}
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default ProfileTabs;